export const USER_SESSION_TOKEN = 'token';
export const APP_SESSION = 'f55_session';
export const X_CODE = 'x-code';
export const APP_TRANSLATIONS = 'f55_translations';
export const APP_PLATFORM = 'platform';
export const APP_PLATFORM_APP_STORE = 'store';

export const APP_LANGUAGE = 'lang';
export const APP_ONE_CLICK_BET = 'f55_one_click_bet';
export const APP_LINE_ABBRS = 'f55_prematch_abbrs';
export const APP_LIVE_ABBRS = 'f55_live_abbrs';
export const APP_LINE_TEMPLATES = 'f55_prematch_templates';
export const APP_LIVE_TEMPLATES = 'f55_live_templates';
export const APP_LIVE_FAVORITES = 'f55_live_favorites';
export const APP_PREMATCH_FAVORITES = 'f55_prematch_favorites';
export const APP_FAVORITES_MIGRATED = 'f55_favorites_migrated';
export const APP_FAVORITES_OWNER = 'f55_favorites_owner';
export const SPORT_GAMES_SESSION_TOKEN = 'f55_session';
export const APP_DOMAIN_ZONE = 'f55_domain_zone';
export const APP_BANNERS_POPUP = 'f55_banners_popup';
export const APP_ENABLE_DEV_CONFIG = 'f55_enable_dev_config';
export const APP_ADMIRAL_FAVORITES = 'f55_admiral_favorites';
export const APP_KEITARO_SUBID = 'f55_keitaro_subid';
export const APP_ILGS_PARAMS = 'f55_ilgs_params';
export const APP_FBCLID = 'f55_fbclid';
export const APP_FBCLID_AT = 'f55_fbclid_at';
export const APP_LCC = 'f55_lcc';
export const APP_PROMO_CODE = 'f55_promo_code';
export const APP_PROMO_CLICK = 'f55_promo_click';
export const APP_VISITOR_ID = 'f55_visitor_id';
export const APP_FIND_WORKING_URL = 'f55_find_working_url';
export const APP_AFFILIATE_CLICK_ID = 'f55_affiliate_click_id';
export const APP_AFFILIATE_OFFER_ID = 'f55_affiliate_offer_id';
export const APP_AFFILIATE_OFFER_TYPE = 'f55_affiliate_offer_type';
export const APP_DEPOSIT_SUCCESS = 'f55_deposit_success';
export const APP_BASKET_LAST_BET_AMOUNT = 'f55_basket_last_bet_amount';
export const APP_HIDE_JIVOCHAT = 'f55_hide_jivochat';
export const APP_ADDS_CLICK_ID = 'f55_adds_click_id';
export const APP_MINI_GAMES_WIN_ID = 'f55_mini_games_win_id';
export const APP_QUIZ_DEVICE = 'f55_quiz_device';
export const APP_QUIZ_CLAIM = 'f55_quiz_claim';
